import React from 'react';
import { UsersIcon } from 'lucide-react';
const TOTAL_SPOTS = 500;
const SPOTS_LEFT = 37;
export function ScarcityBar() {
  const filled = Math.round((TOTAL_SPOTS - SPOTS_LEFT) / TOTAL_SPOTS * 100);
  return <div className="w-full rounded-xl border border-ember/40 bg-ember/10 p-4" data-id="element-45" data-mp="2l3v34pklwc7f">
      <div className="flex items-center justify-between gap-3" data-id="element-46" data-mp="2q3hf6vop7men">
        <span className="flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.14em] text-zinc-200 sm:text-xs" data-id="element-47" data-mp="2q1wo5g1lellj">
          <UsersIcon className="h-4 w-4 text-spark" aria-hidden="true" data-id="element-48" data-mp="2g5l94iambhne" />
          Launch price spots
        </span>
        <span className="font-display text-base font-extrabold uppercase text-spark sm:text-lg" data-id="element-49" data-mp="226tw6z7hs20u">
          Only {SPOTS_LEFT} left
        </span>
      </div>

      <div className="mt-3 h-3 w-full overflow-hidden rounded-full bg-ink-600" role="progressbar" aria-valuemin={0} aria-valuemax={TOTAL_SPOTS} aria-valuenow={TOTAL_SPOTS - SPOTS_LEFT} aria-label={`${SPOTS_LEFT} of ${TOTAL_SPOTS} launch spots remaining`} data-id="element-50" data-mp="276zsisopicp9">
        <div className="h-full rounded-full bg-ember" style={{
        width: `${filled}%`
      }} data-id="element-51" data-mp="2zl9lwb7zpqkg" />
      </div>

      <p className="mt-2.5 text-[12px] leading-snug text-zinc-400" data-id="element-52" data-mp="3dcxy0ei8of1f">
        {TOTAL_SPOTS - SPOTS_LEFT} of {TOTAL_SPOTS} launch spots at $27 have already been claimed.
        When they run out, the price goes back up.
      </p>
    </div>;
}